export default __webpack_public_path__ + "static/media/redtiger-mono.0a55c5e2.svg";